import { Slot } from "radix-ui";
import type { ComponentPropsWithRef } from "react";

import { useFormField } from "./use-form-field";

export function FormControl({ ref, ...props }: ComponentPropsWithRef<typeof Slot.Root>) {
  const { error, formItemId, formDescriptionId, formMessageId } = useFormField();

  return (
    <Slot.Root
      ref={ref}
      id={formItemId}
      aria-describedby={error ? `${formDescriptionId} ${formMessageId}` : formDescriptionId}
      aria-invalid={!!error}
      {...props}
    />
  );
}
